// Response data's from server
let tangent_facemap_data;

var tangent_selfie_id;

// Product ID to single Variant ID mapping
var tangent_selected_product_map;

var default_addToCartText = "Purchase and Ship";
var default_addedToCartText = "Added to Cart!";
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";
var tangent_client_domain_currency;
let addToCartListenerEnabled = false;

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};

const quizURLData = [
    { tag: "MH_CESARE_RPQ", link: "https://www.skinauthority.com/pages/mh-cesare-rpq-quiz" },
    { tag: "HILTON_la_jolla_quiz", link: "https://www.skinauthority.com/pages/hilton-la-jolla" },
    { tag: "MH_CLEMENTS_potranco_quiz", link: "https://www.skinauthority.com/pages/mh-clements-potranco-quiz" },
    { tag: "MH_CLEMENTS_AlamoRanch_quiz", link: "https://www.skinauthority.com/pages/mh-clements-alamoranch-quiz" },
    { tag: "MH_CLEMENTS_Boerne_quiz", link: "https://www.skinauthority.com/pages/mh-clements-boerne-quiz" },
    { tag: "MH_CORP_franchise_quiz", link: "https://www.skinauthority.com/pages/mh-corp-franchise-quiz" },
    { tag: "MH_BUR_tpc_quiz", link: "https://www.skinauthority.com/pages/mh-bur-tpc-quiz" },
    { tag: "MH_BUR_shavano_quiz", link: "https://www.skinauthority.com/pages/mh-bur-shavano-quiz" },
    { tag: "MH_BUR_schertz_quiz", link: "https://www.skinauthority.com/pages/mh-bur-schertz-quiz" },
    { tag: "MH_BUR_medical_quiz", link: "https://www.skinauthority.com/pages/mh-bur-medical-quiz" },
    { tag: "MH_BUR_leon_quiz", link: "https://www.skinauthority.com/pages/mh-bur-leon-quiz" },
    { tag: "MH_BUR_bandera_quiz", link: "https://www.skinauthority.com/pages/mh-bur-bandera-quiz" },
    { tag: "MH_BUR_Alamo_quiz", link: "https://www.skinauthority.com/pages/mh-bur-alamo-quiz" },
    { tag: "MH_BUR_1604_quiz", link: "https://www.skinauthority.com/pages/mh-bur-1604-quiz" },
    { tag: "Carillon_quiz", link: "https://www.skinauthority.com/pages/carillon-miami-wellness-resort-quiz" },
    { tag: "MH_BUR_quiz", link: "https://www.skinauthority.com/pages/mh-bur-quiz" }
];

// Tab title mapping based on tags
var tabs_title_mapping={
  section_starter_routine:"Starter Routine",
  section_individual_product:"Individual Products",
  section_full_light_protection:"Full-Light Protection",
  section_additional_skinconcern:"Additional Concerns",
  section_treatment_recommendation:"Facial Treatments",
  section_body_care:"Massage & Body"
}
// Message for each conditions
var condition_text_mapping = {
  dark_circles:"Prone to dark circles here? Try our <a href='/products/reviving-eye-brightener' target='_blank'><u>Reviving Eye Brightener</u></a>",
  wrinkles:"Prone to wrinkles here? Try our <a href='/products/complete-serum' target='_blank'><u>Complete Serum</u></a>",
  rosacea:"Prone to rosacea here? Try our <a href='/products/calming-mask' target='_blank'><u>Calming Mask</u></a>",
  texture:"Prone to texture here? Try our <a href='/products/resurfacing-accelerator' target='_blank'><u>Resurfacing Accelerator</u></a>",
  darkspots:"Prone to darkspots here? Try our <a href='/products/brightening-serum' target='_blank'><u>Brightening Serum</u></a>",
  acne:"Prone to acne here? Try our <a href='/products/clarifying-liquid-peel' target='_blank'><u>Clarifying Liquid Peel</u></a>"
}

// Add default image url here
var tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/skin-authority/image/3473682158589979-BANNER-PhotoSuppressed.png";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
var tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    addCouponBanner(response);

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // API call for facemapping
    if(response["selfie_id"]!=null){
      setSelfieId(response["selfie_id"]);
      getSelfieMapping(response["selfie_id"]);
      document.getElementById("tangent_score_description").style.display="block";
      document.getElementById("skin-health-title-container").style.display="block";
    }

    appendSectionBelowSelfie(response.tags);
  
    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);

      // Setting 1st tab active by default
      document.querySelector("#tab-wrapper").style.display="block";

      // first tab button and tab content shown by default
      document.querySelector(".tabcontent").style.display="block";
      document.querySelector(".tablinks").classList.add("active");
    }
    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }


    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function hasDiscountQuiz(arr) {
  return arr.includes("discount_quiz");
}

function addCouponBanner(response) {
  const recommendationWrapper = document.getElementById(
    "tangent_recommendation_parent_wrapper"
  );

  if (!recommendationWrapper) return;

  // const hadDiscountTag = hasDiscountQuiz(response.tags)
  // if(!hadDiscountTag) return;

  if (!response.tags.includes("SA_quiz")) return;

  const now = new Date();

  // August 7, 2026 12:00 AM PDT
  const start = new Date("2026-08-07T07:00:00Z");

  // August 10, 2026 11:55 PM PDT
  const end = new Date("2026-08-11T06:55:00Z");

  if (now < start || now > end) return;

  // Prevent duplicate banner
  if (recommendationWrapper.querySelector(".coupon-banner")) return;

  const bannerHtml = `
    <div class="coupon-banner">
      <div class="coupon-banner__content">
        <div class="coupon-banner__text">
          <h2>Enjoy this Summer with Healthier Skin</h2>

          <p class="coupon-banner__offer">
            Use the code
            <strong>ENJOYTHISSUMMER</strong>
            at checkout to get
            <span>25% off</span>
            and kick off your new routine!
          </p>

          <div class="coupon-banner__divider">
            <span></span>
            ★
            <span></span>
          </div>

          <p class="coupon-banner__expiry">
            Valid through August 10 at 11:55 PM PDT. Exclusions may apply.
          </p>
        </div>
      </div>
    </div>
  `;

  recommendationWrapper.insertAdjacentHTML("afterbegin", bannerHtml);
}


function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    if(section!="section_treatment_recommendation"){
      const product_ids = sections[section];
      const product_section_grid = document.getElementById(section + "_product_grid");

      // Create a document fragment for improved performance
      const fragment = document.createDocumentFragment();

      for (const id of product_ids) {
        for (let p = 0; p < products.length; p++) {
          // Find product by ID
          if (String(products[p].id) === id) {
            const product = products[p];
            const variant = getSelectedVariant(product, selected_variants);
              
            const variantId = variant.id;
            // Track selected product variant
            tangent_selected_product_map[product.id] = variantId;
            
            // Generate product HTML and append it to the fragment
            const product_html = getProductHTML(product, p, variant, section, sections, variantId);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;

            // Append the created product HTML to the fragment
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
        }
      }

      // Append the fragment to the DOM in one go
      product_section_grid.appendChild(fragment);
    }
  });
}


function getSelectedVariant(product, selectedVariantsMap = {}) {
    const productVariants = product?.variants || [];

    // No variants available
    if (!productVariants.length) {
        throw new Error("No variants available for the product.");
    }

    // Get the selected variant list for this product
    const variantList = selectedVariantsMap[String(product.id)] || [];
    // If a variant was selected, try to find it
    if (variantList.length > 0) {
        const selectedVariantId = String(variantList[0]);
        const selectedVariant = productVariants.find(
            variant => String(variant.id) === selectedVariantId
        );

        if (selectedVariant) {
            return selectedVariant;
        }

        console.warn(
            `Selected variant ${selectedVariantId} not found for product ${product.id}. Returning default variant.`
        );
    }
    return productVariants[0];
}


function getProductHTML(product, p, variant, section, sections, variantId) {
  
  let buttonText = out_of_stock_text;
  let buttonClass = "disable-btn"
  if(isProductAvailable(product,variant)){
    buttonText = default_addToCartText;
    buttonClass = '';
    updateSectionAllToCartLink(
      section,
      tangent_selected_product_map[product.id]
    );

  }
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant.image_id, product);
  const variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variantId}`;
  
  // Product View HTML using template literals
  return `
    <div>
      <a class="tangent-text-link" target="_blank" href="${variant_product_url}">
        <img src="${variant_image_url}" class="tangent_product_image">
        <p class="tangent-product-title tangent_product_title_text"><b>${product.title}</b></p>
        <p class="tangent_product_price_text">${tangent_client_domain_currency} ${variant.price}</p>
      </a>
      <button class="tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${buttonClass}" id="${variant.id}">
        ${buttonText}
      </button>
      </div>
    </div>
  `;
}

const appendSectionBelowSelfie = (tags) =>{
  const section_container = createElement('tangent_recommendation_info', 'div');
    
  section_container.appendChild(getTextBelowSelfieElement());
  if(getTakeQuizAgainButton(tags)){
    section_container.appendChild(getTakeQuizAgainButton(tags));
  }
  
  appendElementNextTo('tangent_score_description',section_container);
}


const getTextBelowSelfieElement = () =>{
  const recommendation_info_text = createElement('tangent_recommendation_info', 'p');
  recommendation_info_text.innerHTML = "An email has been sent to you with a link to this page for future reference.";
  return recommendation_info_text;
}

const getTakeQuizAgainButton = (tags) => {
  const matchingQuizUrl = findFirstMatchingQuiz(quizURLData, tags);
  if(matchingQuizUrl){
    const quizRetakeButton = createElement('tangent-retake-quiz-button', 'a');
    quizRetakeButton.innerHTML = "START A NEW QUIZ";
    quizRetakeButton.href=matchingQuizUrl.link;
    quizRetakeButton.style.display="flex";
    return quizRetakeButton;
  }
  else{
    return null;
  }
}

const appendElementNextTo = (target_element_id,new_element) => {
  let target_element = document.getElementById(target_element_id);
  target_element.parentNode.insertBefore(new_element, target_element.nextSibling)
}

function isProductAvailable(product, variant) {
  if (!product || !variant) return false;

  const status = product.status?.toUpperCase();

  return (
    status === "ACTIVE" &&
    variant.available_for_sale === true
  );
}

function updateSectionAllToCartLink(sectionName, variantId) {
  // Initialize section if it doesn't exist
  if (!sections_add_to_cart_map[sectionName]) {
    sections_add_to_cart_map[sectionName] = {
      count: 0,
      cart_link: tangent_client_domain_url + "/cart/add?",
      list: []
    };
  }

  const sectionData = sections_add_to_cart_map[sectionName];

  // Prevent duplicate variant IDs
  if (!sectionData.list.includes(variantId)) {
    sectionData.count++;
    sectionData.cart_link += `&id[]=${variantId}`;
    sectionData.list.push(variantId);

    // Show "Add All to Cart" button if more than one product
    const addAllButton = document.getElementById(`${sectionName}`);
    if (addAllButton) {
      addAllButton.style.display =
        sectionData.count > 1 ? "block" : "none";
    }
  }
}

const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

function createFormDataFromIds(idArray, element) {
  const items = idArray.map(id => {
    const item = {
      id,
      quantity: 1
    };
    return item;
  });

  return { items };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id],element);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  let resultText = default_addedToCartText;

  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = resultText;
    element.classList.add("added-to-cart-style"); 
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    var drawer = document.querySelector("cart-drawer"); 
    if(drawer){
        drawer.fullUpdate().then(() => { 
        drawer.open(); }); 
    }
    
  }).catch((error) => {
        element.innerHTML = "Something wrong!";
        console.error('Error:', error);
  });
}

const createElement = (button_id, element_type) =>{
  const element = document.createElement(element_type);
  element.id=button_id;
  return element;
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc]);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
  }
}

function openConditionMessage(canvas,condition){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x:event.clientX - rect.left,
    _y:event.clientY - rect.top
  }
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}

// Custom function for scroll to operation
function scrollToElement(element_id){
  let element;
  if(element_id=="daily_wellbeing"){
     element = document.getElementById('shopify-section-template--16909643743394__featured_text_wH7DN3');
  }
  if(element!=undefined){
    element.scrollIntoView();
  }
}

// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
    var x = pt._x,
      y = pt._y

    var inside = false;
    for(var c=0;c<points_list.length;c++){
      var points = points_list[c];
      for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
        var xi = points[i][0],
          yi = points[i][1]
        var xj = points[j][0],
          yj = points[j][1]
  
        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
        if (intersect) inside = !inside
      }
    }
    return inside
  }

// Toggle - hide higlight button
function hideHightlightButtonDisplayToggle(display){
  document.querySelector("#hideHighlight").style.display=display;
}

// Toggle - show highlight button
function showHighlightButtonDisplayToggle(display) {
  document.querySelector("#showHighlight").style.display=display;  
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    hideHightlightButtonDisplayToggle("block");
    showHighlightButtonDisplayToggle("none");
    selfieCanvasDisplayToggle("block");
  }
  else{
    hideHightlightButtonDisplayToggle("none");
    showHighlightButtonDisplayToggle("block");
    selfieCanvasDisplayToggle("none");
  }
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    section_container.classList.add("tabcontent");
    return section_container;
}

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart");
    add_all_to_cart_button.innerHTML = `Add all to Cart`;

    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

function addSectionProductGridContainer(sectionName) {
    const container = document.createElement("div");

    container.id = `${sectionName}_product_grid`;
    container.className = `section_product_grid ${sectionName}_product_grid`;

    return container;
}

function createTabButton(sectionName) {
    const button = document.createElement("button");

    button.id = `${sectionName}_tab_button`;
    button.name = sectionName;
    button.type = "button";
    button.textContent = getTabTitle(sectionName);
    button.className = "tablinks";
    button.addEventListener("click", () => switchTab(button));
    tangent_custom_tabs.appendChild(button);
    return button;
}

function getTabTitle(section) {
    return tabs_title_mapping?.[section] ??
        section
            .replace(/^section_/, "")
            .replace(/_/g, " ")
            .toUpperCase();
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      createTabButton(section_name);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
    const content = textSections?.[sectionName];

    if (!content?.length) {
        return;
    }

    const sectionDiv = document.createElement("div");
    sectionDiv.id = `${sectionName}_text_container`;
    sectionDiv.className = `section_text_container ${sectionName}_text_container`;
    sectionDiv.innerHTML = content.join(" ");

    sectionContainer.appendChild(sectionDiv);

    return sectionDiv;
}

// Section Text Creation (one without a product section)
function createTextSection(productSections, textSections) {
    const specialContainers = {
        section_selfie: "#section_selfie_container_parent",
        section_additional_content: "#section_additional_content_container_parent"
    };

    for (const [sectionName, content] of Object.entries(textSections)) {
        // Skip sections that already have products
        if (productSections[sectionName] !== undefined) {
            continue;
        }

        // Skip empty content
        if (!Array.isArray(content) || content.length === 0) {
            continue;
        }

        const sectionContainer = createSectionContainer(sectionName);

        const sectionDiv = document.createElement("div");
        sectionDiv.id = `${sectionName}_text_container`;
        sectionDiv.className = `section_text_container ${sectionName}_text_container`;
        sectionDiv.innerHTML = content.join(" ");

        sectionContainer.appendChild(sectionDiv);

        // Handle special placement
        const parentSelector = specialContainers[sectionName];

        if (parentSelector) {
            sectionContainer.classList.remove("tabcontent");

            const parent = document.querySelector(parentSelector);

            if (parent) {
                parent.appendChild(sectionContainer);
            }
        } else {
            tangent_sections_wrapper_element.appendChild(sectionContainer);
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      hideHightlightButtonDisplayToggle("flex");
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          hideHightlightButtonDisplayToggle("flex");
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                hideLoading();
                showSelfieImage();
                document.querySelector('#canvas_img').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
    const sectionName = element.name;

    // Hide all tab contents
    document
        .querySelectorAll(".tabcontent")
        .forEach(tab => (tab.style.display = "none"));

    // Remove active state from all tab buttons
    document
        .querySelectorAll(".tablinks.active")
        .forEach(tab => tab.classList.remove("active"));

    // Show selected tab content
    const content = document.getElementById(`${sectionName}_container`);
    if (content) {
        content.style.display = "flex";
    }

    // Activate selected tab button
    element.classList.add("active");
}

function enableButtonListener() {
    if (addToCartListenerEnabled) {
        return;
    }

    addToCartListenerEnabled = true;

    document.addEventListener("click", function (event) {
        const button = event.target.closest(".tangent-product-add-btn-wrapper");

        if (!button) {
            return;
        }

        addToCart(button);
    });
}

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              setScores(tangent_facemap_data.scores);
              document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);
             
              hideLoading();
              showSelfieImage();
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

function hideLoading() {
    document.querySelector("#loading-section")?.style.setProperty("display", "none");
}

function showSelfieImage() {
    document.querySelector("#canvas_img")?.style.setProperty("display", "block");
}

function findFirstMatchingQuiz(data, tags) {
    return data.find(item => tags.includes(item.tag)) || null;
}

// Setting scores below the selfie
function setScores(scores) {
    const scoreMap = {
        acne: "Acne",
        rosacea: "Rosacea",
        darkspots: "DarkSpots",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    let concernCount = 0;

    Object.entries(scores).forEach(([key, value]) => {
        const prefix = scoreMap[key];

        if (!prefix) {
            return;
        }

        document.getElementById(`${prefix}_Score_container`)?.style.setProperty("display", "flex");

        const scoreElement = document.getElementById(`${prefix}_Score`);
        if (scoreElement) {
            scoreElement.textContent = value;
        }

        concernCount++;
    });

    // Show only if at least one concern is found
    document.getElementById("facemap_all_scores_container")?.style.setProperty(
        "display",
        concernCount > 0 ? "flex" : "none"
    );

    return concernCount;
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas(){
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      
      drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
      drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
      drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
      drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
      drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
      drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}